import { render, staticRenderFns } from "./table.resize.btn.vue?vue&type=template&id=739fc505"
import script from "./table.resize.btn.vue?vue&type=script&lang=js"
export * from "./table.resize.btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports